import React from 'react'
import { observer } from 'mobx-react'
import {
  NotificationBar,
  NotificationBarTitle,
  NotificationBarSubTitle,
  NotificationBarAction,
} from 'components/NotificationBar'
import JobViewModel from '../../../views/JobRoot/Job/JobViewModel'

interface Props {
  vm: JobViewModel
}

export default observer(function RatingsNotificationBar({ vm }: Props) {
  if (!vm.ratingsVM.canSeeRatingNotificationBar) return
  return (
    <NotificationBar dataTest="ratings-notification-bar">
      <NotificationBarTitle>
        Please rate your experience with us.
      </NotificationBarTitle>
      <NotificationBarSubTitle>
        We appreciate any feedback and reviews.
      </NotificationBarSubTitle>
      <NotificationBarAction
        dataTest="ratings-notification-bar-show-rate-dialog"
        onClick={vm.ratingsVM.showRateProDialog}
      >
        Add a review
      </NotificationBarAction>
    </NotificationBar>
  )
})
